const ProductUploadProgressBar = ({ currentStep, steps }) => {
    // Calculate progress as a percentage.
    const progressPercentage = ((currentStep + 1) / steps.length) * 100;

    return (
      <div className="flex flex-col items-center p-2 bg-white rounded-xl ">
        {/* Progress Bar Track */}
        <div className="relative w-full h-3 bg-gray-200 rounded-full overflow-hidden shadow-inner">
          {/* Progress Fill with Gradient */}
          <div
            className="bg-gradient-to-r from-red-200 to-red-600 h-full rounded-full transition-all duration-700 ease-in-out shadow-lg"
            style={{ width: `${progressPercentage}%` }}
          ></div>
        </div>

        {/* Step Indicators */}
        <div className="flex justify-between w-full mt-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`flex flex-col items-center text-center transition-all duration-700 ease-in-out ${
                index <= currentStep ? 'text-red-600' : 'text-gray-400'
              }`}
            >
              {/* Step Icon */}
              <div className={`relative flex items-center justify-center w-6 h-6 rounded-full border-2 ${
                index < currentStep 
                  ? 'bg-red-600 border-red-600' 
                  : index === currentStep 
                    ? 'bg-white border-red-600' 
                    : 'bg-white border-gray-400'
              }`}>
                {index < currentStep ? (
                  <span className="text-white text-xl">✓</span>
                ) : (
                  <span className={`w-3 h-3 rounded-full ${index <= currentStep ? 'bg-red-600' : 'bg-gray-400'}`}></span>
                )}
              </div>
              
              {/* Step Name */}
              <span className={`mt-2 text-sm font-medium ${
                index <= currentStep ? 'text-gray-800' : 'text-gray-500'
              }`}>
                {step.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };

export default ProductUploadProgressBar;